const dataplusLatamPermissions = (action, permissions, institutionId, year) => {
  if (
    action === 'dataplusLatam:viewPage' &&
    permissions[institutionId].includes(`DATAPLUS_LATAM_${year}`)
  ) {
    return true;
  }

  return false;
};

module.exports = {
  dataplusLatamPermissions,
};
